import React from "react";
import { PieceInfoGroupProps } from "./pieceInfoGroup";

export default function DescriptionPieceInfoGroup(props: PieceInfoGroupProps) {
    if(props.piece.description.length === 0) return <></>;
    return <>
        <h4>Description</h4>
        <p>{props.piece.description}</p>
    </>;
}